import type {
  CompetitionId,
  CompetitionView,
  CompetitionsPageEndpointResponse,
  EventTypeView
} from '@ps/isp-web-services-types';
import { type Selector, createSelector } from 'reselect';

import type { RootState, Slicer } from '@swf/core/store';
import type { EventTypesSelector } from '@swf/sports/models/market-templates/meetingBased';
import type { EventTypeId } from '@swf/sports/types/eventType';

import type { SportsCompetitionsState } from './types';

export const selectors = (slice: Slicer<SportsCompetitionsState>) => ({
  competitions: () => slice((state) => state.competitions),
  competition(this: {
    competitions: Selector<RootState, CompetitionsPageEndpointResponse['competitions']>;
  }) {
    return createSelector(
      this.competitions,
      (_state: RootState, competitionId: CompetitionId) => competitionId,
      (competitions, competitionId): CompetitionView => competitions[competitionId]
    );
  },
  eventTypes: () => slice((state) => state.eventTypes),
  eventType(this: { eventTypes: EventTypesSelector }) {
    return createSelector(
      this.eventTypes,
      (_state: RootState, eventTypeId: EventTypeId) => eventTypeId,
      (eventTypes, eventTypeId): EventTypeView => eventTypes[eventTypeId] as EventTypeView
    );
  },
  allCompetitionIds: () => slice((state) => state.allCompetitionIds),
  groups: () => slice((state) => state.groups),
  isLoading: () => slice((state) => state.isLoading),
  errorCode: () => slice((state) => state.errorCode),
  hasPreloaded: () => slice((state) => state.hasPreloaded)
});
